import React, { useMemo } from 'react';
import DayCell from './DayCell';
import styles from './calendar.module.css';

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function toDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function buildMonthGrid(year, monthIndex) {
    const firstOfMonth = new Date(year, monthIndex, 1);
    const startDay = firstOfMonth.getDay();
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, monthIndex, 0).getDate();

    const cells = [];

    for (let i = startDay - 1; i >= 0; i--) {
        cells.push({ date: new Date(year, monthIndex - 1, daysInPrevMonth - i), isCurrentMonth: false });
    }
    for (let day = 1; day <= daysInMonth; day++) {
        cells.push({ date: new Date(year, monthIndex, day), isCurrentMonth: true });
    }
    // pad trailing days so the grid always ends on a full week
    while (cells.length % 7 !== 0) {
        const lastDate = cells[cells.length - 1].date;
        cells.push({ date: new Date(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate() + 1), isCurrentMonth: false });
    }

    return cells;
}

function Calendar({ availability = [], selectedMonth, selectedDate, onSelectDate }) {
    const [year, month] = selectedMonth.split('-').map(Number);

    const availabilityByDate = useMemo(() => {
        const map = new Map();
        availability.forEach((entry) => {
            if (entry?.date) map.set(entry.date, entry);
        });
        return map;
    }, [availability]);

    const cells = useMemo(() => buildMonthGrid(year, month - 1), [year, month]);

    return (
        <div className={styles.calendar}>
            <div className={styles.grid}>
                {WEEKDAY_LABELS.map((label) => (
                    <div key={label} className={styles.weekdayLabel}>{label}</div>
                ))}
                {cells.map(({ date, isCurrentMonth }) => {
                    const dateKey = toDateKey(date);
                    const dayAvailability = availabilityByDate.get(dateKey);
                    const isAvailable = isCurrentMonth && Array.isArray(dayAvailability?.available_slots) && dayAvailability.available_slots.length > 0;

                    return (
                        <DayCell
                            key={dateKey}
                            date={date}
                            isCurrentMonth={isCurrentMonth}
                            isAvailable={isAvailable}
                            isSelected={selectedDate === dateKey}
                            onSelect={() => onSelectDate(dateKey)}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default Calendar;
